export default __webpack_public_path__ + "static/media/Websearch.ea45bb9a.svg";